export default "__VITE_ASSET__BC4MrkoE__$_?url__"